<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        block
        v-on="on"
      >
        Upload File
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Files"
      text="Upload File"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <helper-file-input
                v-model="file" 
                v-validate="'required'" 
                :max-size-in-mb="2"
                :max-number="5"
                :multiple="true"
                data-vv-name="files"
                field-name="files"
                accept-type=".xlsx,.pdf,.docx,.csv,.xls,.doc"
                extension="ext:xlsx,pdf,docx,csv,xls,doc"      
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add file
                  </v-btn>
                  <span> 
                    {{ file ? '' : 'No file chosen (.pdf, .docx, .xlsx, .csv, .xls, .doc only)' }}
                  </span>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <span class="font-weight-bold pl-2">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </div>
              </helper-file-input>
              <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Upload
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    props: {
      parentId: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        file: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
      },
    },

    methods: { 
      prepareFormData () {
        if (this.file) {
          this.file.formData.set('parent', this.parentId)

          return this.file.formData
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.documents().upload(this.prepareFormData())
              .then((res) => {
                this.$emit('uploaded', res.data)                
                this.$snack({ message: 'Uploaded successfully' })

                this.progressing = false
                this.dialog = false
              })
              .catch(() => {
                this.progressing = false
              })
          })
      },
      resetForm () {
        this.$validator.reset()
        this.file = null
      },
    },
  }
</script>
